import { Image } from "antd";

const CustomImage = ({ src = "", preview = false }) => {
  return <Image src={src} preview={preview} />;
};

export default CustomImage;
